import { render } from "./NewAddressModal.vue?vue&type=template&id=17118d9f&scoped=true"
import script from "./NewAddressModal.vue?vue&type=script&lang=ts"
export * from "./NewAddressModal.vue?vue&type=script&lang=ts"

import "./NewAddressModal.vue?vue&type=style&index=0&id=17118d9f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17118d9f"

export default script